import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
   root: {
      backgroundColor: theme.palette.primary.contrastText,
      height: '100vh',
      textAlign: 'center',
   },
   gridImage: {
      paddingTop: 150
   },
   image: {
      width: 280,
      float: 'inherit',
      [theme.breakpoints.down('xs')]: {
         width: 300,
      },
   },
   gridVersion: {
      position: "fixed",
      bottom: 20,
      right: 0,
      left: 0,
      textAlign: 'center',
      marginLeft: 40,
      marginRight: 40,
   },
}))
